<template>
  <router-view />
</template>

<style lang="scss">
#app {
  background: #000000;
  min-height: 100vh;
}
</style>

<script setup>
import { onMounted, onUnmounted } from 'vue'
import { debounce } from 'lodash'

// 防抖处理 ResizeObserver 回调
const debouncedResizeObserver = debounce(() => {
  // 这里可以添加需要防抖的逻辑
}, 100)

// 重写 ResizeObserver 构造函数
onMounted(() => {
  const OriginalResizeObserver = window.ResizeObserver

  window.ResizeObserver = class extends OriginalResizeObserver {
    constructor(callback) {
      const debouncedCallback = debounce(callback, 16) // 约60fps
      super(debouncedCallback)
    }
  }
})

onUnmounted(() => {
  // 清理
  debouncedResizeObserver.cancel()
})
</script>
